import { useAppSelector } from "@/shared/lib/redux"
import { Table } from "@/shared/ui/table"
import { ColumnDef } from "@tanstack/react-table"
import { DropdownButton } from "@/shared/ui/dropdown-button"
import { selectCurrentStatus, selectJobApplications, selectJobApplicationsLoading } from "../../model"
import { IJobApplication } from "@/shared/api/employment"
import UserSvg from '@/shared/assets/images/User.svg' 
import { Loader } from "@/shared/ui/loader"
import { InspectApplication } from "../inspect-application"
import { Link } from "react-router-dom"
import { RejectApplication } from "../reject-application"
import { ApproveApplication } from "../approve-application"
import { getDisplayName } from "@/entities/user"

const ApplicationStatuses = {
    'pending': {
        text: 'НА РАССМОТРЕНИИ',
        color: 'text-color-dark'
    },
    'rejected': {
        text: 'ОТКЛОНЕНА',
        color: 'text-[#C81F22]'
    },
    'reviewed': {
        text: 'ПРИНЯТА',
        color: 'text-[#05CD99]'
    },
}

export const Applications = () => {
    const applications = useAppSelector(selectJobApplications)
    const status = useAppSelector(selectCurrentStatus)
    const applicationsLoading = useAppSelector(selectJobApplicationsLoading)

    const columns: ColumnDef<IJobApplication, any>[] = [
        {
            accessorFn: (application) => (
                <div className="flex gap-2 items-center">
                    <div className="w-9 h-9 bg-color-dark text-white rounded-full flex items-center justify-center">
                        <UserSvg width={29} height={20} />
                    </div>
                    <Link to={`/users/profile/${application.user_id}`} className="text-[13px] text-color-dark font-semibold hover:underline">
                        {getDisplayName(application.user)}
                    </Link>
                </div>
            ),
            enableSorting: false,
            id: 'name',
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Название</div>,
        },
        {
            accessorFn: (application) => (
                <div className="text-[13px] text-color-dark font-semibold">
                    {application.job_opening.name}
                </div>  
            ),
            id: 'salary',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Вакансия</div>,
        },
        {
            accessorFn: () => (
                <div className="text-[13px] text-color-dark font-semibold max-w-full overflow-hidden text-ellipsis text-nowrap">
                    {ApplicationStatuses[status].text}
                </div>
            ),
            id: 'status',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Статус</div>,
        },
        {
            accessorFn: (application) => (
                <div className="w-full flex justify-end">
                    <DropdownButton>
                        <InspectApplication application={application}/>
                        <ApproveApplication application={application}/>
                        <RejectApplication application={application}/>
                    </DropdownButton>
                </div>
            ),
            id: 'actions',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => null,
        },
    ]

    return (
        <div className="p-3 rounded-2xl bg-white screen:rounded-3xl h-full">
            <div className="px-2 pt-3 text-2xl font-mediumttf uppercase">
                Заявки
            </div>
            {Boolean(applications.length) &&
                <div className="max-h-[300px] h-full overflow-auto">
                    <Table columns={columns} data={applications} />
                </div>
            }
            {(!Boolean(applications.length) && applicationsLoading) &&
                <div className="py-3 px-2">
                    <Loader />
                </div>
            }
            {(!Boolean(applications.length) && !applicationsLoading) &&
                <div className="py-3 px-2">
                    Нет данных о заявках
                </div>
            }
        </div>
    )
}